import { useMediaQuery } from "@mui/material";
import { Typography } from "antd";
import React from "react";

export interface TableHeaderBarProps {
  left: React.ReactNode;
  right?: React.ReactNode;
  marginBottom?: React.CSSProperties["marginBottom"];
  gap?: React.CSSProperties["gap"];
  mobileBreakpointQuery?: string;
}

export interface TableHeaderInfoProps {
  title: React.ReactNode;
  count?: React.ReactNode;
  countLabel?: React.ReactNode;
}

export const TableHeaderBar = ({
  left,
  right,
  marginBottom = "1rem",
  gap = "0.75rem",
  mobileBreakpointQuery = "(max-width: 768px)",
}: TableHeaderBarProps) => {
  const isMobile = useMediaQuery(mobileBreakpointQuery);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: isMobile ? "stretch" : "center",
        flexDirection: isMobile ? "column" : "row",
        flexWrap: isMobile ? undefined : "wrap",
        gap,
        marginBottom,
        minWidth: 0,
        maxWidth: "100%",
      }}
    >
      <div
        style={{
          flex: isMobile ? undefined : "1 1 auto",
          flexShrink: 0,
          minWidth: "fit-content",
        }}
      >
        {left}
      </div>
      {right ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: isMobile ? "flex-start" : "flex-end",
            gap,
            width: isMobile ? "100%" : undefined,
            flex: isMobile ? undefined : "1 1 auto",
            minWidth: 0,
            maxWidth: "100%",
          }}
        >
          {right}
        </div>
      ) : null}
    </div>
  );
};

export const TableHeaderInfo = ({
  title,
  count,
  countLabel,
}: TableHeaderInfoProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "center",
        flexWrap: "wrap",
        gap: isMobile ? 4 : 8,
        minWidth: "fit-content",
        whiteSpace: "nowrap",
      }}
    >
      <Typography.Text strong>{title}</Typography.Text>
      {count !== undefined && count !== null ? (
        <Typography.Text italic>
          {count}
          {countLabel ? <> {countLabel}</> : null}
        </Typography.Text>
      ) : null}
    </div>
  );
};
